import { useCallback } from 'react';

import { defaultInstance, skipLoading } from '@ciam/async-utils';
import { useLoginInfoStore } from '@features/shared';
import { useModal } from '@ciam/ui';

export const useTenureExpiredCheck = () => {
  const userInfo = useLoginInfoStore((state) => state.userInfo);
  const { openModal } = useModal();

  const checkTenureExpired = useCallback(
    async ({ uid }: { uid: string }) => {
      // AD 로그인인 경우 tenure expired 체크를 하지 않음
      if (userInfo.isAdLogin) return;

      try {
        const { data } = await defaultInstance.post('/check-tenure', { uid: uid }, skipLoading());
        const tenureExpired = data.tenureExpired ?? 'N';

        if (tenureExpired === 'Y') {
          return (window.location.href = `/ciam-tenure-check${window.location.search}`);
        }
      } catch (error) {
        const err = error as Error;
        openModal({
          type: 'error',
          description: [err.message],
        });
      }
    },
    [openModal, userInfo.isAdLogin],
  );

  return { checkTenureExpired };
};
